module.exports = __webpack_public_path__ + "static/media/search-navs-white.3a15840f.svg";